var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAiFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.378418 8.2666C0.378418 4.12447 3.73628 0.766602 7.87842 0.766602H12.8784C17.0206 0.766602 20.3784 4.12447 20.3784 8.2666V13.2666C20.3784 17.4087 17.0206 20.7666 12.8784 20.7666H7.87842C3.73628 20.7666 0.378418 17.4087 0.378418 13.2666V8.2666Z",
    fill: "#2C60F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3784 15.7666V11.7666H16.3784V15.7666H14.3784Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3784 15.7666V11.7666H15.3784V15.7666H14.3784ZM14.4895 15.5999H15.2673V11.9333H14.4895V15.5999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16748 15.7188H3.37842L7.65115 5.71875H9.10569L13.3784 15.7188H11.5889L8.38232 7.46094L5.16748 15.7188ZM5.7821 12.1399H11.3784V13.2141H5.80482L5.7821 12.1399Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16552 15.7666H3.37842L7.56269 5.7666H9.19415L13.3784 15.7666H11.5913L10.6102 13.3413H6.1466L5.16552 15.7666ZM5.03798 15.6081H3.63715L7.68878 5.9251H9.06806L13.1197 15.6081H11.7189L10.7378 13.1828H6.01906L5.03798 15.6081ZM8.42152 7.45698H8.33532L6.43983 12.1427H10.317L8.42152 7.45698ZM10.0612 11.9842L8.37842 7.82423L6.69561 11.9842H10.0612Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8784 7.7666C14.1225 7.42529 15.094 6.25952 15.3784 4.7666C15.6628 6.25952 16.6343 7.42529 17.8784 7.7666C16.7188 8.1868 15.8008 9.25542 15.4156 10.6336L15.3784 10.7666C15.0915 9.3294 14.1753 8.19357 12.9877 7.80257L12.8784 7.7666Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAiFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-fill.5fa09d53b7a7130fcdc792f76c85a3f9.svg";